import React, { useEffect } from "react";
import { Card, InsetText } from "nhsuk-react-components";

function ConsentInformationScreen() {
  useEffect(() => {
    document.title = "Consent Information - MyHeartPassport";
  }, []);

  return (
    <div className="nhsuk-width-container">
      <main className="nhsuk-main-wrapper" id="maincontent" role="main">
        <div className="nhsuk-grid-row">
          <div className="nhsuk-grid-column-full">
            <h1 className="nhsuk-heading-xl">More Information About Consent</h1>
            
            <p className="nhsuk-body-l">
              This page provides detailed information about the different types of consent available 
              for your cardiac implantable electronic device information.
            </p>

            <Card style={{ marginBottom: "24px", padding: "24px" }}>
              <Card.Heading>
                <h2 className="nhsuk-heading-m">Emergency Access</h2>
              </Card.Heading>
              <Card.Content style={{ padding: "24px" }}>
                <p>
                  Your implanted device may require care in other hospitals, and so we can make your 
                  information rapidly accessible for emergency and other care. By giving consent to this, 
                  you consent to other clinical staff being able to access your implanted device information 
                  when clinically needed, with additional security checks.
                </p>
              </Card.Content>
            </Card>

            <Card style={{ marginBottom: "24px", padding: "24px" }}>
              <Card.Heading>
                <h2 className="nhsuk-heading-m">Research Access</h2>
              </Card.Heading>
              <Card.Content style={{ padding: "24px" }}>
                <p>
                  Your information can help to improve care for patients with cardiac implantable electronic 
                  devices. You will receive an electronic notification requesting consent to use your anonymised 
                  data for research. The research team may also contact you to follow-up or should you meet 
                  eligibility criteria for other studies.
                </p>
              </Card.Content>
            </Card>

            <Card style={{ marginBottom: "24px", padding: "24px" }}>
              <Card.Heading>
                <h2 className="nhsuk-heading-m">Consent to Donation Access</h2>
              </Card.Heading>
              <Card.Content style={{ padding: "24px" }}>
                <p>
                  If the pacemaker is no longer required to your condition, it can be donated to individuals 
                  who need one. The donation is voluntary, and you are not under any obligation to donate the 
                  pacemaker. The donated pacemaker will be used solely for charitable purposes, specifically 
                  to benefit individuals with financial constraints who require a pacemaker. Barts Heart team 
                  will handle the pacemaker donation process, including evaluation, testing, and distribution 
                  to recipients.
                </p>
                <p style={{ marginTop: "16px" }}>
                  By giving consent to this, you consent to donate your pacemaker for the purpose of providing 
                  medical assistance to individuals in need. You authorize Barts Heart team to contact your 
                  healthcare provider to obtain relevant medical records related to the implanted pacemaker 
                  for the purpose of evaluating its suitability for donation.
                </p>
                <InsetText style={{ marginTop: "24px", padding: "24px" }}>
                  <p>
                    <strong>For further information, please access the following link:</strong>
                  </p>
                  <p style={{ marginTop: "8px" }}>
                    <a 
                      href="https://heartrhythmalliance.org/aa/uk/programs/pace4life/register-your-interest" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{ color: "#005eb8" }}
                    >
                      https://heartrhythmalliance.org/aa/uk/programs/pace4life/register-your-interest
                    </a>
                  </p>
                </InsetText>
              </Card.Content>
            </Card>

            <Card style={{ marginBottom: "24px", padding: "24px" }}>
              <Card.Heading>
                <h2 className="nhsuk-heading-m">Full Access</h2>
              </Card.Heading>
              <Card.Content style={{ padding: "24px" }}>
                <p>
                  You consent to all types of access that includes emergency access, research access, 
                  donation access and non-emergency access (e.g. GP visit, clinic visit). With Full Access, 
                  authorised healthcare professionals and other permitted parties can view all relevant 
                  information in your passport as needed for your care, safety, or approved purposes.
                </p>
              </Card.Content>
            </Card>
          </div>
        </div>
      </main>
    </div>
  );
}

export default ConsentInformationScreen;

